import { Input } from '@angular/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DropdownComponent } from '@woolworthsnz/form';
import { BreakPointService, Device, PaginationComponent } from '@woolworthsnz/styleguide';
import { SearchMediatorService } from '../search-mediator.service';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'search-pagination',
	templateUrl: './search-pagination.component.html',
	styleUrls: ['./search-pagination.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, PaginationComponent, DropdownComponent, AsyncPipe],
})
export class SearchPaginationComponent {
	@Input() itemsPerPageCollection: string[];
	@Input() currentPageSize: number;
	@Input() currentPage: number;
	@Input() totalItems: number;
	@Input() canChangePageSize = true;

	device = Device;

	constructor(public breakPointService: BreakPointService, public searchMediatorService: SearchMediatorService) {}

	canShowPagination = (itemsCount: number): boolean => itemsCount > this.currentPageSize;

	onPageChange = (page: number): void => this.searchMediatorService.emitPageChangeEvent(page);

	onPageSizeChange = (size: number): void => this.searchMediatorService.emitPageSizeChangeEvent(size);
}
